import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { checkChanges } from '../../utils/checkChanges';
import {
  NEW_STAFF_PROMPT,
} from '../../constants/promptMessages';

import List from './List';
import Overview from './Overview';
import Activities from './Activities';
import New from './New';
import Import from './Import';

export default class Staffs extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static Activities = Activities
  static Overview = checkChanges(Overview)
  static New = checkChanges(New, { message: NEW_STAFF_PROMPT })
  static Import = checkChanges(Import)

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child)
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Staffs/Staffs.jsx